// "Schedule Alex screen" from a submitted candidate (candidate pipeline, bundle 4a-2): fills the candidate's name,
// e-mail and resume into the Phase 3 schedule wizard. The resume comes through a 5-minute read link; if it can't be
// fetched the recruiter attaches it by hand (the wizard's own check asks for it).
const BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export async function prefillCandidate(candidateId, jobId, { setCandidateName, setCandidateEmail, setResume, setPhase3Error }) {
  try {
    const r = await fetch(`${BASE}/api/candidates/${candidateId}/schedule-prefill?requirement_id=${jobId}`,
      { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
    if (!r.ok) return;
    const d = await r.json();
    setCandidateName(d.candidate_name || '');
    setCandidateEmail(d.candidate_email || '');
    if (!d.resume || !d.resume.url) return;
    const f = await fetch(d.resume.url);
    if (!f.ok) throw new Error('resume');
    const blob = await f.blob();
    setResume(new File([blob], d.resume.filename || 'resume.pdf', { type: d.resume.content_type || blob.type }));
  } catch (e) {
    setPhase3Error("The candidate's resume couldn't be attached automatically — please attach it.");
  }
}
